import BigNumber from 'bignumber.js';
import { LARGE_POSITIVE_INT } from '../contants';

export const getPairsFromTpsl = (
	takeProfitInput: string,
	stopLossInput: string,
	isLong: boolean
) => {
	const isTakeProfit = new BigNumber(takeProfitInput).gt(0);
	const isStopLoss = new BigNumber(stopLossInput).gt(0);

	let firstPairA = '0x000';
	let firstPairB = '0x000';
	let secondPairA = '0x000';
	let secondPairB = '0x000';

	if (isTakeProfit) {
		if (isLong) {
			firstPairA = takeProfitInput;
			firstPairB = LARGE_POSITIVE_INT;
		} else {
			firstPairA = '1';
			firstPairB = takeProfitInput;
		}
	}
	if (!isTakeProfit && isStopLoss) {
		if (isLong) {
			firstPairA = '1';
			firstPairB = stopLossInput;
		} else {
			firstPairA = stopLossInput;
			firstPairB = LARGE_POSITIVE_INT;
		}
	}
	if (isTakeProfit && isStopLoss) {
		if (isLong) {
			secondPairA = '1';
			secondPairB = stopLossInput;
		} else {
			secondPairA = stopLossInput;
			secondPairB = LARGE_POSITIVE_INT;
		}
	}

	return { firstPairA, firstPairB, secondPairA, secondPairB };
};
